module.exports = __webpack_public_path__ + "media/images/topografia_icon-938773f86c97642de202e4d80fd6751c.png";